module.exports = __webpack_public_path__ + "coursecatalogwp656af7303a30326877116834c8a810b0.png";